
import { TextField, Button, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { useCallback, useEffect, useState } from "react";
import { UBItem } from "./UBItem"

export const UBHourlyFilter = ({value, onChange}) => {
    const [date, setDate] = useState(value);

    const onApply = useCallback((e) => {
        onChange(date.clone());
    }, [date, onChange]);

    return (
        <UBItem styles={{display: 'flex', justifyContent: 'end', alignItems: 'center'}}>
            <Typography
                sx={{ mr: "auto", ml: 2 }}
                variant="h5"
                fontWeight="bold"
                align="left"
                alignSelf="center"
                component="div"
            >
                Filter
            </Typography>

            <DatePicker
                label="Date"
                value={date}
                onChange={newValue => setDate(newValue)}
                renderInput={(params) => <TextField variant="standard" sx={{marginLeft: "auto"}} {...params} />}
            />

            <Button
                onClick={onApply}
                sx={{ color: 'white', borderColor: 'white', display: 'block', textTransform: 'none', ml: 2 }}
            >
                <Typography variant="h6" fontWeight="bold" align="left">Refresh</Typography>
            </Button>
        </UBItem>
    );
}